const projectsArray = [
  {
    id: 1,
    image: "/images/projects/shop-project.jpg",
    title: "React-project (whithout adaptation)",
    ukrTitle: "Навчальний проект на реакті (без адаптації)",
    link: "react-online-zt-diana.netlify.app/",
    gitLink: "gitlab.com/skillup-react-12-06/dzayats",
  },
  {
    id: 2,
    image: "/images/projects/modest-project.jpg",
    title: "Modest-project (adaptation, slider, burger-menu)",
    ukrTitle: "Навчальний проект 'Modest' (адаптація, слайдер, випадаюче-меню)",
    link: "ztdiana.github.io/blog-modest-site/#slide-1",
    gitLink: "github.com/ztDiana/blog-modest-site",
  },
  {
    id: 3,
    image: "/images/projects/blog-page.jpg",
    title: "Blog-project (adaptation, slider)",
    ukrTitle: "Навчальний проект 'Blog' (адаптація, слайдер)",
    link: "ztdiana.github.io/progect-work/",
    gitLink: "github.com/ztDiana/progect-work",
  },
  {
    id: 4,
    image: "/images/projects/weather-project.jpg",
    title: "Weather-project with API(adaptation, slider, API)",
    ukrTitle: "Навчальний проект 'Weather' (адаптація, слайдер, API)",
    link: "ztdiana.github.io/my-weather/",
    gitLink: "github.com/ztDiana/my-weather",
  },
  {
    id: 5,
    image: "/images/projects/demo-shop.jpg",
    title: "Demo Shop-project (one of the first)",
    ukrTitle:
      "Навчальний проект 'Shop-demo' (один з перших на повноцінне розташування елементів)",
    link: "ztdiana.github.io/shop-project/",
    gitLink: "github.com/ztDiana/shop-project",
  },
];
export default projectsArray;
